// tslint:disable

import * as React from 'react';
import { TextAreaField } from '../../components/fields/textarea.field';
import {FormLib} from '../../components/libs/form.lib';
import {ResourceLoader} from '../../components/libs/resource-loader';
import {DefaultSave} from '../../components/libs/updaters/default-save';
import {LoaderComponent} from '../../components/structurals/loader.component';
import {ToggleBoxComponent} from '../../components/structurals/toggle-box.component';
import {IriField} from "../../components/fields/iri.field";
import {CheckboxField} from "../../components/fields/checkbox.field";
import {InputField} from "../../components/fields/input.field";
import {DatepickerField} from "../../components/fields/datepicker.field";
import {AxiosResponse} from "axios";
import {Environment} from "../../environment/environment";
import axios from "axios";


export class DefaultPoint extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public state: any = {
        reason: null
    };

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    private async updatePointValue(reason: any, form: FormLib) {
        this.setState({reason: reason})

        const response: AxiosResponse = await axios.get(`${Environment.get('api.base')}${reason}`, {
            withCredentials: true,
        });

        if (!response.data) {
            throw new Error('OOooooOOO! Ohh...');
        }

        form.fields.pointCount.setValue(response.data.pointValue);
    }

    render() {
        return (
            <ResourceLoader entity="point" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Add new point' : 'Edit point'}
                    </h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <div className="row">
                    <div className="col-md-12">
                        <ToggleBoxComponent title="Details" color="green" alwaysOpen={true}>
                            <div className="row">
                                <div className="col-xs-12">
                                    <IriField
                                        field={form.fields.person}
                                        itemRender={(item: any) => `${item.firstName} ${item.surName} - ${item.email}`}
                                    />

                                    <IriField
                                        field={form.fields.reason}
                                        itemRender={(item: any) => item.title}
                                        defaultAll={true}
                                        forceQuery={{'public': false}}
                                        onChange={(value: any) => this.updatePointValue(value, form)}
                                    />

                                    <InputField
                                        field={form.fields.pointCount}
                                    />

                                    <DatepickerField
                                        field={form.fields.receivedAt}
                                        defaultValue=""
                                    />

                                    <DatepickerField
                                        field={form.fields.acceptedAt}
                                        defaultValue=""
                                    />

                                    <CheckboxField
                                        field={form.fields.correction}
                                    />

                                    <TextAreaField
                                        field={form.fields.comment}
                                    />

                                    <button className="btn btn-success pull-left"
                                            onClick={() => this.saveForm(form)}>Save
                                    </button>

                                </div>
                            </div>
                        </ToggleBoxComponent>
                    </div>
                </div>
            </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.point.tsx